module.exports = __webpack_public_path__ + "static/media/banner_slider_2.08a8b7b7.jpeg";